import { render } from "./Motivation.component.vue?vue&type=template&id=bd0155ce"
import script from "./Motivation.component.vue?vue&type=script&lang=js"
export * from "./Motivation.component.vue?vue&type=script&lang=js"

import "./Motivation.component.vue?vue&type=style&index=0&id=bd0155ce&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCardActions,QBtn});
